//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { billChartApi, billChangeBie } from '@/api/enterprise';
import { numberFormat } from '../../../../utils/numberFormat.js';
export default {
  name: 'FinanceChart',
  components: {
    statisticsBox: function statisticsBox() {
      return import('./components/statisticsBox');
    },
    echartBox: function echartBox() {
      return import('@/components/common/echarts');
    },
    tabListChart: function tabListChart() {
      return import('./components/tabListChart');
    },
    defaultPage: function defaultPage() {
      return import('@/components/common/defaultPage');
    }
  },
  data: function data() {
    return {
      time: '',
      optionData: {},
      pieChartData1: {},
      pieChartData2: {},
      pieChartBtn1: false,
      pieChartBtn2: false,
      styles1: {
        height: '300px',
        width: '100%'
      },
      expenditureId: '',
      expenditure: '支出',
      expenditureList: [{
        name: '支出',
        cate_id: 0,
        types: 2
      }],
      activeId: '',
      active: '收入',
      incomeList: [{
        name: '收入',
        cate_id: 0,
        types: 1
      }],
      incomeValue: 1,
      expendValue: 1,
      tableDataIncome: [],
      tableDataExpend: [],
      showNumber: 5
    };
  },
  mounted: function mounted() {},
  methods: {
    // 点击切换饼状图
    pieChange: function pieChange(data) {
      var _this = this;
      if (data.types == 1) {
        this.active = data.name;
        if (this.activeId == data.cate_id) {} else {
          this.activeId = data.cate_id;
          this.deconstruction(data);
          this.$nextTick(function () {
            _this.incomeList.push(data);
          });
        }
      } else {
        this.expenditure = data.name;
        if (this.expenditureId == data.cate_id) {} else {
          this.expenditureId = data.cate_id;
          this.deconstruction(data);
          this.$nextTick(function () {
            _this.expenditureList.push(data);
          });
        }
      }
    },
    // 收入面包屑
    changeActive: function changeActive(row, index) {
      this.active = row.name;
      this.incomeList.splice(index + 1);
      if (row.name == '收入') {
        this.incomeList = [{
          name: '收入',
          cate_id: 0,
          types: 1
        }];
        this.deconstruction(row);
      } else {
        this.deconstruction(row);
      }
    },
    // 支出面包屑
    changeExpenditure: function changeExpenditure(row, index) {
      this.expenditure = row.name;
      this.expenditureList.splice(index + 1);
      if (row.name == '支出') {
        this.expenditureList = [{
          name: '支出',
          cate_id: 0,
          types: 2
        }];
        this.deconstruction(row);
      } else {
        this.deconstruction(row);
      }
    },
    // 获取饼状图数据
    deconstruction: function deconstruction(data) {
      var _this2 = this;
      if (data.types == 2) {
        data.types = 0;
      }
      var item = {
        time: this.time,
        types: data.types,
        cate_id: data.cate_id
      };
      billChangeBie(item).then(function (res) {
        if (res.data.length > 0) {
          if (data.types == 1) {
            _this2.shouruChart(res.data);
          } else {
            _this2.zhichuChart(res.data);
          }
        }
      });
    },
    // 切换样式
    clickTab: function clickTab(tab) {
      var _this3 = this;
      if (tab === 1) {
        if (!this.pieChartBtn1) {
          this.pieChartBtn1 = true;
          this.$nextTick(function () {
            _this3.$refs.tabListChart01.scrollAnimate();
          });
        } else {
          this.pieChartBtn1 = false;
          this.$refs.tabListChart01.stop();
        }
      } else if (tab === 2) {
        if (!this.pieChartBtn2) {
          this.pieChartBtn2 = true;
          this.$nextTick(function () {
            _this3.$refs.tabListChart02.scrollAnimate();
          });
        } else {
          this.pieChartBtn2 = false;
          this.$refs.tabListChart02.stop();
        }
      }
    },
    // 趋势图
    xianchart: function xianchart(data) {
      // 趋势图
      this.optionData = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: [this.$t('finance.revenueamount'), this.$t('finance.expenditureamount')],
          show: true,
          right: 10,
          top: 0
        },
        grid: {
          left: 0,
          top: 40,
          right: 20,
          bottom: 0,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          nameTextStyle: {
            color: '#CCCCCC'
          },
          axisLine: {
            lineStyle: {
              color: '#CCCCCC'
            }
          },
          axisLabel: {
            color: '#666666'
          },
          data: []
        },
        dataZoom: {
          type: 'inside'
        },
        yAxis: {
          type: 'value',
          name: this.$t('finance.amountmoney'),
          nameTextStyle: {
            color: '#CCCCCC'
          },
          axisLine: {
            lineStyle: {
              color: '#CCCCCC'
            }
          },
          axisLabel: {
            color: '#666666'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [{
          name: this.$t('finance.totalrevenue'),
          type: 'line',
          itemStyle: {
            normal: {
              color: '#19BE6B'
            }
          },
          smooth: true,
          lineStyle: {
            width: 3
          },
          data: []
        }, {
          name: this.$t('finance.totalexpenditure'),
          type: 'line',
          itemStyle: {
            normal: {
              color: '#FF9900'
            }
          },
          smooth: true,
          lineStyle: {
            width: 3
          },
          data: []
        }]
      };
      this.optionData.xAxis.data = data.xAxis;
      this.optionData.series[0].name = data.series[0].name;
      this.optionData.series[0].data = data.series[0].data;
      this.optionData.series[1].name = data.series[1].name;
      this.optionData.series[1].data = data.series[1].data;
    },
    // 收入饼状图
    shouruChart: function shouruChart(data) {
      var incomeLegendData = [];
      var incomeSeriesData = [];
      this.pieChartData1 = {
        color: ['tomato', 'deepskyblue', 'orange', 'mediumseagreen', 'violet', 'dodgerblue', 'khaki', 'turquoise', 'salmon', 'darkslategray'],
        //中心标题
        title: {
          text: '',
          top: '42%',
          right: '61%'
        },
        // 鼠标移动展示
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        // 分类
        legend: [{
          type: 'scroll',
          orient: 'vertical',
          right: '0%',
          // 距离右侧位置
          itemGap: 18,
          itemHeight: 16,
          // 图标大小设置
          icon: 'circle',
          data: incomeLegendData,
          y: 'center',
          pageIconSize: 12,
          textStyle: {
            fontSize: 12,
            color: '#333',
            lineHeight: 16,
            // 解决提示语字显示不全
            rich: {
              a: {
                padding: [0, 10, 0, 10],
                color: '#FF0000'
              },
              b: {
                color: '#666'
              }
            }
          },
          formatter: function formatter(name) {
            var target;
            var ratio;
            for (var i = 0; i < data.length; i++) {
              if (data[i].name === name) {
                target = numberFormat(data[i].sum);
                ratio = data[i].ratio;
              }
            }
            var arr = [name + '{a|' + target + '元' + '}' + '{b|' + ratio + '%' + '}'];
            return arr.join('\n');
          }
        }],
        series: [{
          name: this.$t('finance.sourceincome'),
          type: 'pie',
          radius: '55%',
          right: '40%',
          data: incomeSeriesData,
          label: {
            show: true
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      this.tableDataIncome = data;
      if (data.length > 0) {
        data.forEach(function (val, index) {
          incomeLegendData.push(val.name);
          incomeSeriesData.push({
            value: val.sum,
            name: val.name,
            cate_id: val.cate_id,
            types: 1
          });
        });
      }
    },
    // 支出饼状图
    zhichuChart: function zhichuChart(data) {
      this.tableDataExpend = data;
      var expendLegendData = [];
      var expendSeriesData = [];
      // 支出
      this.pieChartData2 = {
        color: ['#5B8FF9', '#5AD8A6', '#5D7092', '#F6BD16', '#E8684A', '#87CEFA'],
        title: {
          text: '',
          top: '42%',
          right: '61%'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: [{
          type: 'scroll',
          orient: 'vertical',
          right: '0%',
          // 距离右侧位置
          itemGap: 18,
          itemHeight: 16,
          // 图标大小设置
          icon: 'circle',
          data: expendLegendData,
          y: 'center',
          pageIconSize: 12,
          textStyle: {
            fontSize: 12,
            color: '#333',
            lineHeight: 16,
            // 解决提示语字显示不全
            rich: {
              a: {
                padding: [0, 10, 0, 10],
                color: '#FF0000'
              },
              b: {
                color: '#666'
              }
            }
          },
          formatter: function formatter(name) {
            var target;
            var ratio;
            for (var i = 0; i < data.length; i++) {
              if (data[i].name === name) {
                target = numberFormat(data[i].sum);
                ratio = data[i].ratio;
              }
            }
            var arr = [name + '{a|' + target + '元' + '}' + '{b|' + ratio + '%' + '}'];
            return arr.join('\n');
          }
        }],
        series: [{
          name: this.$t('finance.sourceexpenditure'),
          type: 'pie',
          radius: '55%',
          right: '40%',
          center: ['40%', '50%'],
          data: expendSeriesData,
          label: {
            show: true
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      if (data.length > 0) {
        data.forEach(function (val, index) {
          expendLegendData.push(val.name);
          expendSeriesData.push({
            value: val.sum,
            name: val.name,
            cate_id: val.cate_id,
            types: 2
          });
        });
      }
    },
    getChartList: function getChartList(data) {
      var _this4 = this;
      billChartApi(data).then(function (res) {
        var cdata = res.data;
        _this4.xianchart(cdata);
        _this4.shouruChart(cdata.incomeRank);
        _this4.zhichuChart(cdata.expendRank);
      });
    },
    confirmData: function confirmData(data) {
      this.time = data.time;
      this.expenditureList = [{
        name: '支出',
        cate_id: 0,
        types: 2
      }];
      this.incomeList = [{
        name: '收入',
        cate_id: 0,
        types: 1
      }];
      this.incomeValue = 1;
      this.expendValue = 1;
      this.getChartList(data);
    }
  }
};